import { Component, OnInit, SimpleChanges ,OnChanges, Input} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { DefaultFilter } from 'ng2-smart-table';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { DatePickerService } from '../../services/helpers/date-picker.service';
import { Subject } from 'rxjs-compat';
@Component({
  selector: 'ngx-date-picker-filter',
  template:`
     <!-- <input class="datePicker" nbInput placeholder="Date" [nbDatepicker]="formcontrol" [formControl]="inputControl">
      <nb-datepicker #formcontrol></nb-datepicker> -->
     <input
              type="date"
              [formControl]="inputControl"
              class="form-control"
              nbInput
              fullWidth
              placeholder="{{ 'Date' | translate }}"
            />
      `,
  styleUrls: ['./date-picker-filter.component.scss']
})
export class DatePickerFilterComponent  extends DefaultFilter implements OnInit ,OnChanges{
  inputControl = new FormControl();
  datePipe = new DatePipe("en-US")
  newValue :Subject<any>
  constructor(
    private changeDatePicker:DatePickerService

  ) {
    super();
    this.newValue = this.changeDatePicker.valueDate
    this.newValue.subscribe(value => {
      this.inputControl.setValue( value);
    });
  }

  ngOnInit(): void {
    this.inputControl.valueChanges
    .pipe(
      distinctUntilChanged(),
      debounceTime(this.delay),
    )
    .subscribe((value: string) => {
      if(this.inputControl.status === 'VALID')
      {
        this.query = value !== null ?  this.datePipe.transform(this.inputControl.value,'yyyy-MM-dd') : "";
        this.setFilter();
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
  if (changes.query) {
      this.query = changes.query.currentValue;
      this.inputControl.setValue(this.inputControl.value);
      this.newValue = this.changeDatePicker.valueDate
    this.newValue.subscribe(value => {
      this.inputControl.setValue( value);
    });
    }
  }
}
